<template>
    <div id="dynamic-dropdown-container">
        <kendo-dropdownlist
            v-if="loaded"
            v-model="selectedId"
            :data-source="items"
            :data-text-field="isEnVersion ?  textField + 'En' : textField"
            :data-value-field="valueField"
            :optionLabel="$t('choose')"
            @change="inputChanged"
            :name="'dropdown' + _uid"
            :data-vv-as="fieldName"
            v-validate="required ? 'required' : ''"
            :no-data-template="noDataTemplate"
            :popup="bindPopup && popupContainerId ? popup : {}"
            style="width: 100%;"
            :clear-button="clearButton"
            :height="height"
            :filter="filterPattern"
            :auto-width="autoWidth"
            :disabled="disabled"
            :footer-template="nomDropdownSettings.showFooterTemplate ? footerTemplate : ''"
        ></kendo-dropdownlist>
        <span
            class="text-danger col-12"
            v-if="errors.has('dropdown' + _uid)"
        >{{ errors.first('dropdown' + _uid) }}</span>

        <DropdownSettings
            v-if="loaded"
            :filterPattern.sync="filterPattern"
            :show.sync="showSettings"
        ></DropdownSettings>
    </div>
</template>

<script>
import Vue from "vue";
import FooterTemplate from "@/components/grid/NomenclatureDropdownFooterTemplate";
import DropdownSettings from "@/components/common/DropdownSettings";
import { mapGetters } from "vuex";
export default {
    inject: ["$validator"],
    components: {
        DropdownSettings,
    },
    props: {
        apiUrl: {
            type: String,
            required: true,
        },
        value: [String, Number],
        required: {
            type: Boolean,
            default: false,
        },
        valueField: {
            type: String,
            default() {
                return 'id'
            }
        },
        textField: {
            type: String,
            default() {
                return 'text'
            }
        },
        fieldName: String,
        registerName: String,
        filter: {
            type: String, // startswith, endswith, contains
            default: "none",
        },
        height: {
            type: Number,
            default: 400, // Default value for Kendo DropdownList
        },
        itemsFromParent: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        clearButton: {
            type: Boolean,
            default: true,
        },
        autoWidth: {
            type: Boolean,
            default: false,
        },
        hasStringId: {
            type: Boolean,
            default: false,
        },
        showGoToSelection: {
            type: Boolean,
            default: true,
        },
        bindPopup: {
            type: Boolean,
            default: false,
        },
        popupContainerId: {
            type: String,
            default: "",
        },
        applyFilterObject: {
            type: Boolean,
            default: false,
        },
        filterObject: Object
    },
    data() {
        return {
            selectedId: this.value,
            items: [],
            changedFromDropdown: false,
            loaded: false,
            showSettings: false,
            filterPattern: "",
            popup: {
                appendTo: $(this.popupContainerId),
            },
        };
    },
    methods: {
        loadItems() {
            if (this.itemsFromParent.length > 0) {
                this.items = this.itemsFromParent;
                this.loaded = true;
            } else {
                // TODO: Loading
                this.$http
                    .get(this.apiUrl, { params: { value: this.value, applyFilterObject: this.applyFilterObject, filter: this.filterObject } })
                    .then((result) => {
                        // TODO
                        this.items = [];
                        result.data.forEach((item) => {
                            this.items.push({
                                id: item.id,
                                text:
                                    this.isEnVersion && item.textEn
                                        ? item.textEn
                                        : item.text,
                                isRegisterField: item.isRegisterField,
                                item: item
                            });
                        });

                        this.loaded = true;
                        // this.items = result.data;
                    })
                    .catch((error) => {
                        // TODO: Toast
                    })
                    .then(() => {
                        this.textChanged(this.value);
                    });
            }
        },
        inputChanged(event) {
            this.changedFromDropdown = true;
            const selectedValue = event.sender.value();

            if (this.hasStringId) {
                // Id-to e UID
                let val = selectedValue;
                let item = this.items.filter((i) => {
                    return i.id === val;
                });
                this.$emit("input", val, item);
                this.$emit("change", val, item);
            } else {
                const val = parseInt(selectedValue);
                const item = this.items.filter((i) => {
                    return i.id === val;
                });
                this.$emit("input", val, item);
                this.$emit("change", val, item);
            }

            if (this.selectedId !== selectedValue) {
                this.selectedId = selectedValue;
            }

            this.textChanged(selectedValue);
        },
        footerTemplate: function (e) {
            return {
                template: Vue.component(FooterTemplate.name, FooterTemplate),
                templateArgs: {
                    ...e,
                    btns: [
                        {
                            name: "dynamicDropdownSettings",
                            text: this.$t("buttons.settings.btnText"),
                            tooltip: this.$t("buttons.settings.btnText"),
                            class: "btn btn-secondary",
                            icon: "fas fa-cog",
                            show: this.nomDropdownSettings.showSettings,
                            clickHandler: () => {
                                this.showSettings = true;
                            },
                        },
                    ],
                },
            };
        },
        refresh() {
            this.loadItems();
        },
        textChanged(val) {
            try {
                let text = '';
                let items = this.items.filter((i) => {
                    // eslint-disable-next-line eqeqeq
                    return i.id == val;
                });

                if (items && Array.isArray(items) && items.length > 0) {
                    text = items[0].text;
                }

                this.$emit("textChanged", text);
            } catch {
                // Ignore
            }
        }
    },
    mounted() {
        if (this.filterObject !== undefined) {
            this.$watch('filterObject', function(newValue, oldValue) {
                this.refresh();
            }, { deep: true });
        }

        this.filterPattern = this.filter !== 'none' ? this.filter : this.nomDropdownSettings.defaultFilterPattern;
        this.loadItems();
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal, oldVal) {
                if (this.changedFromDropdown) {
                    this.changedFromDropdown = false;
                    return;
                }
                this.selectedId = newVal;
            },
        },
        apiUrl: {
            immediate: true,
            handler(newVal, oldVal) {
                if (this.changedFromDropdown) {
                    this.changedFromDropdown = false;
                    return;
                }
                this.apiUrl = newVal;
                this.loadItems();
            },
        },
    },
    computed: {
        ...mapGetters(['isEnVersion', 'nomDropdownSettings']),
        noDataTemplate() {
            let msg = `${this.$t('dynamicDropdown.noDataFound')}  ${
                this.fieldName
            }.`;
            if (this.showGoToSelection) {
                msg += ` ${this.$t("dynamicDropdown.goToSection")}  ${
                    this.registerName ? this.registerName : this.fieldName
                }.`;
            }

            return msg;
        },
    },
};
</script>
